import { render, staticRenderFns } from "./ReplyReceiveMessageDetail.vue?vue&type=template&id=6e91f288&scoped=true&lang=pug"
import script from "./ReplyReceiveMessageDetail.vue?vue&type=script&lang=ts"
export * from "./ReplyReceiveMessageDetail.vue?vue&type=script&lang=ts"
import style0 from "./ReplyReceiveMessageDetail.vue?vue&type=style&index=0&id=6e91f288&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e91f288",
  null
  
)

export default component.exports